import React, { Component } from 'react';

class DeviceCellRender extends Component {
    render() {
        return  <div>
                    <b>{this.props.data.icn.deviceIdType}</b> {this.props.data.icn.deviceId}
                </div>
    }
}

export default DeviceCellRender;


// WEBPACK FOOTER //
// ./src/components/table/cellRenderers/DeviceCellRender.js